import { message, Modal, Input } from 'antd'
import React from 'react'
import _props from '../props'
import { createRamsRecord, updateRamsRecord } from '../../../HttpRequests/ramsRecords'
import handleException from '../../../Core/Helpers/handleException'

var TextArea = Input.TextArea

function promptForRevisionComment() {
  return new Promise(function(resolve, reject) {
    var commentValue = ''

    Modal.confirm({
      title: 'Revision Comment',
      content: React.createElement(
        'div',
        null,
        React.createElement('p', { style: { marginBottom: 8 } }, 'Please describe what was changed in this update:'),
        React.createElement(TextArea, {
          rows: 3,
          placeholder: 'e.g. Updated PPE requirements, changed valid dates...',
          onChange: function(e) { commentValue = e.target.value },
        })
      ),
      okText: 'Save',
      cancelText: 'Cancel',
      width: 480,
      onOk: function() {
        if (!commentValue || !commentValue.trim()) {
          message.warning('Please enter a revision comment')
          return Promise.reject()
        }
        resolve(commentValue.trim())
      },
      onCancel: function() {
        reject('cancelled')
      },
    })
  })
}

export default (values) => async (dispatch, getState) => {

  try {

    const { projectId, ramsRecordId, onClose } = _props.get()

    const { files, removedFileIds } = getState().modals.RamsRecord

    // If updating, prompt for revision comment before proceeding
    var revisionComment = null
    if (ramsRecordId) {
      try {
        revisionComment = await promptForRevisionComment()
      } catch (e) {
        // User cancelled the prompt
        return
      }
    }

    const data = new FormData();

    data.append('project_id', projectId)
      if (typeof values.client_contact_id != "undefined")
        data.append('client_contact_id', values.client_contact_id)
      if (typeof values.hs_contact_id != "undefined")
        data.append('hs_contact_id', values.hs_contact_id)
    data.append('valid_from', values.valid_from)
    data.append('valid_to', values.valid_to)
    data.append('notes', values.notes || '')

    if (!values.services)
        values.services = [];

    if (values.services.length === 0) {
      data.append('services', '')
    } else {
      values.services.forEach((item) => {
        data.append('services[]', item)
      })
    }

    if (!values.access_equipment)
        values.access_equipment = [];

    if (values.access_equipment.length === 0) {
      data.append('access_equipment', '')
    } else {
      values.access_equipment.forEach((item) => {
        data.append('access_equipment[]', item)
      })
    }

    if (!values.paints)
        values.paints = [];

    if (values.paints.length === 0) {
      data.append('paints', '')
    } else {
      values.paints.forEach((item) => {
        data.append('paints[]', item)
      })
    }

    if (!values.ppe)
        values.ppe = [];

    if (values.ppe.length === 0) {
      data.append('ppe', '')
    } else {
      values.ppe.forEach((item) => {
        data.append('ppe[]', item)
      })
    }

    if (!values.training)
        values.training = [];

    if (values.training.length === 0) {
      data.append('training', '')
    } else {
      values.training.forEach((item) => {
        data.append('training[]', item)
      })
    }

    if (values.spray_timing) {
      data.append('spray_timing', values.spray_timing)
    }

    if (values.nearest_ae_name) {
      data.append('nearest_ae_name', values.nearest_ae_name)
    }

    if (values.nearest_ae_address) {
      data.append('nearest_ae_address', values.nearest_ae_address)
    }

    if (values.scope) {
      data.append('scope', values.scope)
    }

    if (values.site_access) {
      data.append('site_access', values.site_access)
    }

    if (values.deliveries) {
      data.append('deliveries', values.deliveries)
    }

    if (values.welfare) {
      data.append('welfare', values.welfare)
    }

    if (values.induction_requirements) {
      data.append('induction_requirements', values.induction_requirements)
    }

    if (!values.tasks)
        values.tasks = [];

    if (values.tasks.length === 0) {
      data.append('tasks', '')
    } else {
      values.tasks.forEach((item) => {
        data.append('tasks[]', item)
      })
    }

    if (!values.coshh)
        values.coshh = [];

    if (values.coshh.length === 0) {
      data.append('coshh', '')
    } else {
      values.coshh.forEach((item) => {
        data.append('coshh[]', item)
      })
    }

    data.append('manual_pdf_upload', values.manual_pdf_upload ? '1' : '0')

    files.filter(file => file.status !== 'done').forEach((file) => {
      data.append('files[]', file.originFileObj)
    })

    removedFileIds.forEach(id => {
      data.append('removed_file_ids[]', id)
    })

    if (ramsRecordId) {

      if (revisionComment) {
        data.append('revision_comment', revisionComment)
      }

      await updateRamsRecord({ id: ramsRecordId, data })

      message.success("RAMS Updated")

      onClose(true)

    } else {

      await createRamsRecord({ data })

      message.success("RAMS Created")

      onClose(true)

    }

  } catch (error) {

    handleException(error)

  }

}

